export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const SET_CATEGRORIES = 'SET_CATEGRORIES';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SET_TODAY_PRODUCTS = 'SET_TODAY_PRODUCTS'; 
export const SET_PRODUCTS_TO_SHOW = 'SET_PRODUCTS_TO_SHOW';
export const SET_ASC_PRODUCTS_TO_SHOW = 'SET_ASC_PRODUCTS_TO_SHOW';
export const SET_DESC_PRODUCTS_TO_SHOW = 'SET_DESC_PRODUCTS_TO_SHOW';
